import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { NgxDropzoneChangeEvent } from "ngx-dropzone";
import { EvaluatorService } from "src/app/core/services/evaluator.service";
import { HttpClient } from "@angular/common/http";
import Swal from "sweetalert2";
import { NgxExtendedPdfViewerService } from "ngx-extended-pdf-viewer";

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.css"],
})
export class FileUploadComponent implements OnInit {
  selectedFile: File;
  isLoading: boolean = false;
  pdfSrc;
  public formData = {};
  public isReady: boolean = false

  constructor(
    public dialogRef: MatDialogRef<FileUploadComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
    private evaluatorService: EvaluatorService,
    private httpClient: HttpClient,
    private NgxExtendedPdfViewerService: NgxExtendedPdfViewerService
  ) { }

  ngOnInit() {
    switch (this.data.type) {
      case 0:
        this.pdfSrc = "../../../assets/documents/work_permit_final.pdf";
        this.fetchFile(this.pdfSrc, "workpermit.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      case 1:
        this.pdfSrc = "../../../assets/documents/yellow-card.pdf";
        this.fetchFile(this.pdfSrc, "yellow-card.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      case 2:
        this.pdfSrc = "../../../assets/documents/green-card.pdf";
        this.fetchFile(this.pdfSrc, "green-card.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      case 3:
        this.pdfSrc = "../../../assets/documents/PINK CARD.pdf";
        this.fetchFile(this.pdfSrc, "pink-card.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      case 4:
        this.pdfSrc = "../../../assets/documents/BLUE CARD.pdf";
        this.fetchFile(this.pdfSrc, "blue-card.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      case 5:
        this.pdfSrc = "../../../assets/documents/FINAL-NSRP-FORM.pdf";
        this.fetchFile(this.pdfSrc, "nsrp-form.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      case -1:
        this.pdfSrc = "../../../assets/documents/cert-of-attendance.pdf";
        this.fetchFile(this.pdfSrc, "seminar.pdf").then(
          (file) => (this.pdfSrc = file)
        );
        break;
      default:
        break;
    }
    const applicant = this.data.applicant;
    this.formData = {
      date: new Date().toDateString().toUpperCase(),
      estab_address: this.data.application.occupationEstablishmentAddress
        .toString()
        .toUpperCase(),
      applicant_age: this.calculateAge(this.data.applicant.birthDate)
        .toString()
        .toUpperCase(),
      applicant_address:
        `${applicant.presentStreetName} ${applicant.presentBarangay} ${applicant.presentCity.name}`
          .toString()
          .toUpperCase(),
      applicant_ctc: this.data.application.officialReceipts
        .filter((e) => e.receiptType == 4)[0]
        ?.receiptNumber.toString()
        .toUpperCase(),
      ctc_date_issued: new Date(
        this.data.application.officialReceipts.filter(
          (e) => e.receiptType == 4
        )[0]?.dateIssued
      ),
      ctc_place_issued: "BAGUIO CITY",
      permit_no: this.data.application.apn.toString().toUpperCase(),
      applicant_name_a: this.data.application.applicantName
        .toString()
        .toUpperCase(),
      applicant_name_b: this.data.application.applicantName
        .toString()
        .toUpperCase(),
      occupation_a: this.data.application.occupation.toString().toUpperCase(),
      occupation_b: this.data.application.occupation.toString().toUpperCase(),
      estab_name_a: this.data.application.occupationEstablishment
        .toString()
        .toUpperCase(),
      estab_name_b: this.data.application.occupationEstablishment
        .toString()
        .toUpperCase(),
      year_a: new Date().getFullYear().toString().substring(2),
      year_b: new Date().getFullYear().toString().substring(2),
      day_month: new Date().toLocaleDateString(undefined, {
        month: "long",
        day: "numeric",
      }),
      or_no: this.data.application.officialReceipts
        .filter((e) => e.receiptType == 3)[0]
        ?.receiptNumber.toString()
        .toUpperCase(),
      ptr_no: this.data.application.officialReceipts
        .filter((e) => e.receiptType == 2)[0]
        ?.receiptNumber.toString()
        .toUpperCase(),
      sex: applicant.gender.toString().toUpperCase(),
      hso_engr: "",
      hso_officer: "",
      reg_no: "",
      address_street: applicant.presentStreetName,
      address_barangay: applicant.presentBarangay,
      address_city: applicant.presentCity.name,
      birth_date: this.getFormattedDate(applicant.birthDate),
      is_male: applicant.gender === 'M' ? "YES" : "NO",
      is_female: applicant.gender === 'F' ? "YES" : "NO",
      is_single: applicant.civilStatus === 'Single' ? "YES" : "NO",
      is_married: applicant.civilStatus === 'Married' ? "YES" : "NO",
      is_widowed: applicant.civilStatus === 'Widowed' ? "YES" : "NO",
      tin_id: applicant.tin,
      height_ft: `${applicant.heightFt}'${applicant.heightInches}`,
      contact_number: applicant.contactNumber,
      email: applicant.email,
      is_visual: applicant.isVisuallyDisabled === true ? "YES" : "NO",
      is_hearing: applicant.isHearingDisabled === true ? "YES" : "NO",
      is_speech: applicant.isSpeechDisabled === true ? "YES" : "NO",
      is_physical: applicant.isPhysicallyDisabled === true ? "YES" : "NO",
      is_psycho: applicant.isPsychosocialDisabled === true ? "YES" : "NO",
      is_employed: applicant.isPsychosocialDisabled === true ? "YES" : "NO",


    };

    setTimeout(() => {
      this.isReady = true
    }, 2000);

  }


  getFormattedDate(dateString: string): string {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  calculateAge(birthdate: string): number {
    const birthDate = new Date(birthdate);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    // If the current month is before the birth month,
    // or it's the birth month but the day is yet to come, subtract one year from the age.
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  private async fetchFile(path: string, filename): Promise<File> {
    try {
      const response = await this.httpClient
        .get(path, { responseType: "blob" })
        .toPromise();
      return new File([response], filename, { type: "application/pdf" });
    } catch (error) {
      console.error("Error fetching file:", error);
      return null;
    }
  }

  async handleFileUpload() {
    const blob =
      await this.NgxExtendedPdfViewerService.getCurrentDocumentAsBlob();

    Swal.fire({
      title: "Are you sure?",
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonColor: "#e74c3c",
      confirmButtonColor: "#4DAF50",
    }).then((result) => {
      if (result.isConfirmed) {
        this.isLoading = true;
        const body = {
          ApplicationId: this.data.application.id,
          FileDescription:
            this.data.type == 0
              ? "Working Permit"
              : this.data.type == 1
                ? "Yellow Card"
                : this.data.type == 2
                  ? "Green Card"
                  : this.data.type == 3
                    ? "Pink Card"
                    : this.data.type == 4
                      ? "Blue Card"
                      : this.data.type == 5
                        ? "NSRP Form"
                        : "Certificate of Attendance",
          FileType: this.data.type,
          FileSize: "",
          AccessLevel: "",
        };

        if (blob) {
          const filename =
            this.data.type == 0
              ? "Working Permit"
              : this.data.type == 1
                ? "Yellow Card"
                : this.data.type == 2
                  ? "Green Card"
                  : this.data.type == 3
                    ? "Pink Card"
                    : this.data.type == 4
                      ? "Blue Card"
                      : this.data.type == 5
                        ? "NSRP Form"
                        : "Certificate of Attendance"
          const file = new File(
            [blob],
            `${this.data.application.applicantName}` + filename,
            { type: blob.type }
          );
          body["File"] = file;
        }

        this.evaluatorService.uploadSupportFile(body).subscribe((res) => {
          this.isLoading = false;
          window.location.reload();
          this.dialogRef.close();
        });
      } else if (result.isDenied) {
        this.isLoading = false;
        return;
      }
    });
  }
}
